// © 2015-2021 WDNA - All Rights Reserved
import { UserDO } from 'wdna-components';

import history from '../../store/history';

export default class Auth {
  /**
   * Authenticate a user. Save a token string in Storage
   *
   * @param user user object
   */
  public static authenticateUser(user: UserDO): void {
    Auth.setToken(user.api_token || '');
    Auth.setUser(user);
  }

  /**
   * Check if a user is authenticated - check if a token is saved in Storage
   *
   * @returns true if user is authenticated false otherwise
   */
  public static isUserAuthenticated(): boolean {
    return Auth.getToken() !== null;
  }

  /**
   * Deauthenticate a user. Remove a token from Storage.
   *
   * @param clear indicates if session storage must be cleared
   */
  public static deauthenticateUser(clear: boolean = false): void {
    localStorage.removeItem('count');
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    if (clear) sessionStorage.clear();

    // TODO: fixe user redux
    window.store.dispatch({
      type: 'REMOVE_USER',
    });

    // Redirect to login window
    setTimeout(() => {
      history.replace('/login');
    }, 0);
  }

  /**
   * Save a token string in Storage
   *
   * @param token user api token
   */
  public static setToken(token: string): void {
    localStorage.setItem('token', token);
    sessionStorage.setItem('token', token);
  }

  /**
   * Get a token value.
   *
   * @returns with the user token
   */
  public static getToken(): string | null {
    return localStorage.getItem('token') ? localStorage.getItem('token') : sessionStorage.getItem('token');
  }

  /**
   * Save a user info in Storage
   *
   * @param user User info object to save
   */
  public static setUser(user: UserDO): void {
    if (user) {
      const value: string = JSON.stringify(user);
      localStorage.setItem('user', value);
      sessionStorage.setItem('user', value);
    }
  }

  /**
   * Get the current user information in the storage
   *
   * @returns With the user information or null
   */
  public static getUser(): UserDO | null {
    const user: string | null = localStorage.getItem('user') ? localStorage.getItem('user') : sessionStorage.getItem('user');
    return user ? JSON.parse(user) as UserDO : null;
  }

  /**
   * Save the browser timezone into storage
   */
  public static setTimeZone(): void {
    localStorage.setItem('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
  }

  /**
   * Get a browser time-zone value.
   *
   * @returns time-zone name of the browser
   */
  public static getTimeZone(): string | null {
    return localStorage.getItem('timezone');
  }

  /**
   * Function to check authentication on close browser window/tab
   *
   * @param load indicates if is load tab/window or not
   */
  public static chkAuthFront(load: boolean): void {
    const def: number = (load ? 0 : 1);
    const inc: number = (load ? +1 : -1);

    const oldCount: string | null = localStorage.getItem('count');
    const newCount: number = (oldCount ? parseInt(oldCount, 10) : def) + inc;
    localStorage.setItem('count', `${newCount}`);

    // To avoid desconnection on reload page
    if (load && sessionStorage.getItem('token') != null && localStorage.getItem('token') == null) {
      localStorage.setItem('token', sessionStorage.getItem('token') || '');
      localStorage.setItem('user', sessionStorage.getItem('user') || '');
    }
    if (!load && sessionStorage.getItem('token') == null && localStorage.getItem('token') != null) {
      sessionStorage.setItem('token', localStorage.getItem('token') || '');
      sessionStorage.setItem('user', localStorage.getItem('user') || '');
    }

    if (!load && newCount < 1) {
      this.deauthenticateUser();
    }
  }
}
